import React from 'react';
import Terms from 'ui/legal/terms.mdx';
import InvisibleBox from 'ui/components/common/dumb/InvisibleBox';
import { useTranslation } from 'react-i18next';
import inMainScreen from 'ui/components/hocs/inMainScreen';

const TermsOfService: React.FC = () => {
  const { t } = useTranslation(['policies']);
  return (
    <InvisibleBox>
      <InvisibleBox.Row>
        <InvisibleBox.Heading>{t('policies:termsOfService')}</InvisibleBox.Heading>
      </InvisibleBox.Row>
      <InvisibleBox.Row>
        <Terms />
      </InvisibleBox.Row>
    </InvisibleBox>
  );
};

export default inMainScreen(TermsOfService);
